import { trackEvent } from 'services/Gtm/functions';
import { EventData } from 'services/Gtm/entities';
import { COMMON_TEST_IDS } from 'constants/testsIds/common';
import * as S from './PrevRoundArrowStyles';

export interface PrevArrowProps {
  className?: string;
  onClick?: () => void;
  trackingData?: EventData;
  dataCy?: string;
  ariaLabel?: string;
  showFade?: boolean;
}

const PrevRoundArrow = ({
  className = '',
  onClick,
  trackingData,
  dataCy = '',
  ariaLabel,
  showFade = false,
}: PrevArrowProps) => (
  <>
    <S.PrevButtonShaded className={`${className} prev-shade${showFade ? ' show-fade' : ''}`} />
    <S.PrevArrowWrapper
      className={`${className} prev`}
      onClick={() => {
        if (onClick) onClick();
        if (trackEvent && trackingData) trackEvent({ ...trackingData, eventLabel: 'previous arrow click' });
      }}
      data-cy={dataCy || COMMON_TEST_IDS.PREVIOUS_ARROW}
      aria-label={ariaLabel ?? 'Previous'}
      aria-labelledby='Previous Button'
      role='presentation'
      title='Previous Button'
    >
      <S.PrevArrow />
    </S.PrevArrowWrapper>
  </>
);

export default PrevRoundArrow;
